@if (isVisible) {
  <dialog class="pwa-popup" open="">
    <div class="pwa-icon-box">
      <img class="pwa-icon" src="../../../assets/icons/192x192.png" alt="Wüstenrot PIS Icon" />
      <div>
        <p class="large-bold">Wüstenrot PIS</p>
        <p>App installieren</p>
      </div>
    </div>

    @if (installationType === 'chrome') {
      <p class="mt-4 mb-4">Sie können diese App auf Ihrem Smartphone installieren und jederzeit einfach zugreifen.</p>
      <div class="chrome-install-buttons">
        <button (click)="onInstall()" class="install-button">
          <img src="../../../assets/icons/chrome-install.svg" alt="Chrome Install Icon" />
          Installieren
        </button>
        <button (click)="onClose()" class="skip-button">Später</button>
      </div>
    } @else {
      <p class="mt-4 mb-4">Sie können diese App auf Ihrem iPhone installieren und jederzeit einfach zugreifen.</p>
      <div class="instruction">
        <p>1. Tippen Sie auf</p>
        <div class="badge"><img src="../../../assets/icons/ios-share.svg" alt="Teilen Icon" /></div>
      </div>
      <div class="instruction mt-3">
        <p>2. Wählen Sie</p>
        <p class="badge">Zum Home-Bildschirm</p>
      </div>
    }

    <form method="dialog">
      <button (click)="onClose()" class="close-button">
        <img src="../../../assets/icons/x.svg" alt="Schließen" />
      </button>
    </form>
  </dialog>
}
